module.exports = __webpack_public_path__ + "static/media/default-06-April.2325dabc.jpg";